import { canonical, clash, lineWords, listWords, unread } from '@verlo/shared/lib/allergens';

// The send check: which of the lines about to go to the kitchen contain something this
// table can't have, and haven't yet been given an allergy note for the kitchen.
//
// Only unsent lines (no `line_id`): a dish already with the kitchen was checked when it was
// sent. A line that already carries an allergy note has been dealt with ("no cheese"); the
// check is for the dish nobody has said anything about.
//
// A dish stops the send for two reasons. `clash`: it lists something the table can't have.
// `check`: it lists a word the till can't read ("butter", "nuts (almond)"), so the till
// can't tell, and a dish it can't tell about is not one to wave through at a table with an
// allergy. Either way the server asks, and says what the kitchen should do.

export function clashingLines(cart, tableAllergens, menuById = {}) {
  if (!tableAllergens?.length) return [];
  const out = [];
  (cart || []).forEach((line, index) => {
    if (line?.line_id) return;
    if ((line?.allergy_notes || '').trim()) return;
    const words = lineWords(line, menuById);
    const hit = clash(canonical(words), tableAllergens);
    const check = unread(words);
    if (hit.length || check.length) out.push({ index, line, clash: hit, check });
  });
  return out;
}

/** What one hit is about, after the dish's name: "contains milk", "lists butter, which the
 * till can't check", or both. */
export function hitWords(hit) {
  const parts = [];
  if (hit.clash?.length) parts.push(`contains ${listWords(hit.clash)}`);
  if (hit.check?.length) parts.push(`lists ${hit.check.join(', ')}, which the till can't check`);
  return parts.join(' and ');
}

/** The cart with the kitchen's notes written onto the lines the check was about. */
export function withAllergyNotes(cart, notesByIndex) {
  return cart.map((line, i) => (notesByIndex[i] ? { ...line, allergy_notes: notesByIndex[i].trim() } : line));
}

/** The cart without the lines the server chose to take off. */
export function withoutLines(cart, indexes) {
  const drop = new Set(indexes);
  return cart.filter((_, i) => !drop.has(i));
}
